module.exports = __webpack_public_path__ + "img/gb1235-76-12.prt.a70c4bf2.jpg";